import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly KEY = 'theme';
  isDark = false;

  constructor() {
    const saved = localStorage.getItem(this.KEY);
    this.isDark = saved ? saved === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.apply();
  }

  toggle(): void {
    this.isDark = !this.isDark;
    localStorage.setItem(this.KEY, this.isDark ? 'dark' : 'light');
    this.apply(true);
  }

  /**
   * Apply the theme. When `animateless` is true (an explicit toggle), we add a
   * `theme-switching` class that disables color transitions for one frame so the
   * whole UI flips to the new theme instantly and in sync — no staggered fade
   * between the sidebar and the main area.
   */
  private apply(animateless: boolean = false): void {
    const body = document.body;
    if (animateless) {
      body.classList.add('theme-switching');
    }

    body.classList.toggle('dark', this.isDark);

    if (animateless) {
      // Remove the guard after the browser has painted the new colors.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => body.classList.remove('theme-switching'));
      });
    }
  }
}
